// extracted by mini-css-extract-plugin
export default {"sidebar":"tmmp1"};